"use client";

import React from "react";
import dynamic from "next/dynamic";
import RouteOneFinancingButton from "@/components/finance/RouteOneFinancingButton";
import type { IntentVehicleContext } from "@/types/prequalify";
import styles from "../VehicleDetailsPage.module.css";

const ContactFormModal = dynamic(() => import("./ContactFormModal"), {
    ssr: false
});

interface VehicleHeroCTAsProps {
    vehicleVin: string | null;
    vehicleName: string | null;
    vehicleImage?: string | undefined;
    vehicleMileage?: number | undefined;
    vehiclePrice?: number | undefined;
    stockId?: string | undefined;
    dealerName?: string | undefined;
    financingUrl?: string | null | undefined;
    financingVehicle: IntentVehicleContext;
}

export default function VehicleHeroCTAs({
    vehicleVin,
    vehicleName,
    vehicleImage,
    vehicleMileage,
    vehiclePrice,
    stockId,
    dealerName,
    financingUrl,
    financingVehicle
}: VehicleHeroCTAsProps) {
    if (!vehicleVin || !vehicleName) return null;

    return (
        <>
            <ContactFormModal
                vehicleVin={vehicleVin}
                vehicleName={vehicleName}
                vehicleImage={vehicleImage}
                vehicleMileage={vehicleMileage}
                vehiclePrice={vehiclePrice}
                stockId={stockId}
                dealerName={dealerName}
                buttonId="vdp-check-availability"
                buttonClassName={styles["primaryCta"]!}
                buttonText="">
                <span>Check Availability</span>
            </ContactFormModal>
            <RouteOneFinancingButton
                buttonId="vdp-get-pre-approved"
                configuredUrl={financingUrl}
                vehicle={financingVehicle}
                pageSection="vdp_primary"
                ariaLabel={`Get financed for the ${vehicleName}`}
                className={styles["secondaryCta"]!}>
                Get Financed
            </RouteOneFinancingButton>
            <p className={styles["credit"]}>Financing application opens in a new tab.</p>
        </>
    );
}
